// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { useLocalMessage } from '@Helpers/';
import THDrawer from '@Molecules/THDrawer/THDrawer';
import useValidateForm from '@Hooks/useValidateForm';
import { SAMLForm, SAMLInput } from './SAMLForm';

interface SAMLManageProps {
    defaultValues?: SAMLInput;
    triggerElem?: ReactElement;
    onFinish: (task: SAMLInput) => Promise<any>;
    visible?: boolean;
    onVisibleChange?: (visible: boolean) => void;
    needDueDate?: boolean;
    forbiddenNames?: string[];
}

export const SAMLManage = ({
    defaultValues,
    triggerElem,
    onFinish,
    visible,
    onVisibleChange,
    forbiddenNames = [],
}: SAMLManageProps): ReactElement => {
    const i = useLocalMessage();
    const { form, isValid, onFormValuesChange, fieldsTouched, setFieldsTouched } = useValidateForm();

    return (
        <THDrawer
            title={
                defaultValues
                    ? i('configPlateform.saml.provider.drawer.edit.title')
                    : i('configPlateform.saml.provider.drawer.add.title')
            }
            triggerElem={triggerElem}
            className="drawer-form"
            visible={visible}
            afterVisibleChange={(visible) => {
                form.resetFields();
                onVisibleChange?.(visible);
            }}
            disableClose={fieldsTouched}
        >
            {(toggleDrawer) => (
                <SAMLForm
                    forbiddenNames={forbiddenNames}
                    onFinish={({ another, ...values }) => {
                        onFinish(values as SAMLInput).then(() => {
                            if (!another) {
                                toggleDrawer();
                                return;
                            }

                            form.resetFields();
                            onFormValuesChange();
                            setFieldsTouched(false);
                        });
                    }}
                    form={form}
                    defaultValues={defaultValues}
                    onChange={() => {
                        onFormValuesChange();
                        setFieldsTouched(true);
                    }}
                    isValid={isValid && fieldsTouched}
                    onCancel={() => {
                        toggleDrawer();
                        form.resetFields();
                        setFieldsTouched(false);
                    }}
                />
            )}
        </THDrawer>
    );
};
